import { SensorModelSchema, NodeSchema } from '../requests/api/apiTypes';
import { SensorNode } from '../types';

export const SET_FARM_DEVICE = '@account-farm/set-farm-device';
export const SET_ALL_FARM_DEVICES = '@account-farm/set-all-farm-devices';
export const SET_SENSOR_NODE_FILTER = '@account-farm/set-node-sensor-filter';
export const SET_SENSOR_TYPE = '@account-farm/set-sensor-type';
export const SET_DASHBOARD_TYPE = '@account-farm/set-dashboard-type';
export const RESET_FARM_SECTOR_STATE = '@account-farm/reset-farm-sector-state';

export const setFarmDevice = (deviceId: string) => ({
  type: SET_FARM_DEVICE,
  payload: deviceId,
});

export const setAllFarmDevices = (devices: Array<NodeSchema | SensorModelSchema>) => ({
  type: SET_ALL_FARM_DEVICES,
  payload: devices,
});

export const setSensorNodeFilter = (sensorNodeInfo: SensorNode) => ({
  type: SET_SENSOR_NODE_FILTER,
  payload: sensorNodeInfo,
});

export const setSensorType = (sensorType: string) => ({
  type: SET_SENSOR_TYPE,
  payload: sensorType,
});

export const setDashboardType = (dashboardType: number) => ({
  type: SET_DASHBOARD_TYPE,
  payload: dashboardType,
});

export const resetFarmSectorState = () => ({
  type: RESET_FARM_SECTOR_STATE,
});
